module.exports = __webpack_public_path__ + "img/ranking-4.d9615aed.svg";